import React from "react";

import { ChatDetails } from "./Chat";

export const ChatContext = React.createContext<
	[ChatDetails | undefined, (details: ChatDetails | undefined) => void]
>([undefined, partner => undefined]);
